import { PostcodeTicketVerifyRequest } from '../client/src';
import { VerifyChildPostcodeTicket } from '../types';

export const formatPostcodeTicketVerify = (
  verify: VerifyChildPostcodeTicket
): PostcodeTicketVerifyRequest => {
  const result: PostcodeTicketVerifyRequest = {
    postCode: verify.postCode,
    ticketID: verify.ticketID.toString(),
    applicantDOB: verify.dateOfBirth.toISOString().substring(0, 10),
  };
  return result;
};
